
import React from 'react'
import { mdx } from '@mdx-js/react'
export const readingTime = {"text":"1 min read","minutes":0.425,"time":25500,"words":85}
/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Ce site présente une partie des résultats de travaux réalisés dans le cadre du projet  `}<a parentName="p" {...{
        "href": "https://medialab.sciencespo.fr/activites/algoglitch/"
      }}>{`Algoglitch`}</a>{` au médialab de Sciences Po. Il articule des analyses descriptives et des visualisations de données, portant sur un corpus d’articles de presse sur le thème de l’IA et des algorithmes couvrant une période de 5 années aux États-Unis et au Royaume-Uni. A partir de méthodes de traitement automatique du langage sur un corpus de presse, cette recherche vise à explorer les discours critiques sur l’IA dans la sphère médiatique. `}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
export const tableOfContents = (components={}) => [
  
]

export const frontMatter = {}

